import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable()
export class SubdomainInterceptor implements HttpInterceptor {
  private getClientFromUrl(): string | null {
    const { hostname, href } = window.location;

    if (href.includes('localhost:4201')) {
      const pathSegments = href.split('/').filter(Boolean);
      return pathSegments.length > 2 ? pathSegments[2] : null;
    }

    if (href.includes('localhost:4202')) {
      console.log('SubdomainInterceptor: Detected localhost:4202, using "admin" as client');
      return 'admin';
    }

    const domainParts = hostname.split('.');
    if (domainParts.length > 1) {
      return domainParts[0]; // Return the subdomain part
    }

    return null;
  }

  private createXOriginHeaderValue(): string | null {
    const client = this.getClientFromUrl();

    if (client) {
      return `https://${client}${environment.domainName}`;
    }

    return null;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const xOrigin = this.createXOriginHeaderValue();
    if (!xOrigin) {
      console.warn('SubdomainInterceptor: No X-Origin header set, client could not be determined from URL', window.location);
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: {
          'X-Origin': xOrigin,
        },
      })
    );
  }
}
